import * as React from "react";
import { ReactNode } from "react";

export function HighlightedText(props: { children: ReactNode }) {
  return (
    <span className={"inline-block p-4 bg-primary tracking-widest"}>
      {props.children}
    </span>
  );
}
